// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreatePaymentRuleInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/create_payment_rule
 *
 * Validates input for creating a new payment rule.
 */
import { registerContract } from './validate'

export interface Payroll_CreatePaymentRuleInput {
user_id: string
franchise_id: number
rule_type: string
amount: number
description?: string
meta?: string
}

registerContract('Payroll_CreatePaymentRuleInput', {
  user_id:      { type: 'string',  required: true },
  franchise_id: { type: 'number',  required: true },
  rule_type:    { type: 'string',  required: true },
  amount:       { type: 'number',  required: true },
  description:  { type: 'string',  required: false },
  meta:         { type: 'string',  required: false },
})
